/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Auto_Select_Next_Event_HelpInputs */

const en_options_editor_auto_select_next_event_help = /** @type {(inputs: Options_Editor_Auto_Select_Next_Event_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically select the next event when the start timecode is updated.`)
};

const fr_options_editor_auto_select_next_event_help = /** @type {(inputs: Options_Editor_Auto_Select_Next_Event_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner automatiquement l'événement suivant lorsque le code temporel de début est mis à jour.`)
};

const de_options_editor_auto_select_next_event_help = /** @type {(inputs: Options_Editor_Auto_Select_Next_Event_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das nächste Ereignis wird automatisch ausgewählt, sobald der Startzeitcode aktualisiert wird.`)
};

const it_options_editor_auto_select_next_event_help = /** @type {(inputs: Options_Editor_Auto_Select_Next_Event_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona automaticamente l'evento successivo quando il timecode di inizio viene aggiornato.`)
};

const ru_options_editor_auto_select_next_event_help = /** @type {(inputs: Options_Editor_Auto_Select_Next_Event_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматический выбор следующего события при обновлении временного кода начала.`)
};

const es_options_editor_auto_select_next_event_help = /** @type {(inputs: Options_Editor_Auto_Select_Next_Event_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar automáticamente el próximo evento cuando se actualiza el código de tiempo de inicio.`)
};

const zh_cn2_options_editor_auto_select_next_event_help = /** @type {(inputs: Options_Editor_Auto_Select_Next_Event_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当开始时间码更新时，自动选择下一个事件。`)
};

const ja_options_editor_auto_select_next_event_help = /** @type {(inputs: Options_Editor_Auto_Select_Next_Event_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始タイムコードが更新されると、次のイベントが自動的に選択されます。`)
};

const hi_options_editor_auto_select_next_event_help = /** @type {(inputs: Options_Editor_Auto_Select_Next_Event_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रारंभ समय कोड अपडेट होने पर अगले इवेंट का स्वचालित रूप से चयन करें।`)
};

const pt_pt2_options_editor_auto_select_next_event_help = /** @type {(inputs: Options_Editor_Auto_Select_Next_Event_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar automaticamente o próximo evento quando o código de tempo inicial for atualizado.`)
};

/**
* | output |
* | --- |
* | "Automatically select the next event when the start timecode is updated." |
*
* @param {Options_Editor_Auto_Select_Next_Event_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_auto_select_next_event_help = /** @type {((inputs?: Options_Editor_Auto_Select_Next_Event_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Auto_Select_Next_Event_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_auto_select_next_event_help(inputs)
	if (locale === "de") return de_options_editor_auto_select_next_event_help(inputs)
	if (locale === "it") return it_options_editor_auto_select_next_event_help(inputs)
	if (locale === "ru") return ru_options_editor_auto_select_next_event_help(inputs)
	if (locale === "es") return es_options_editor_auto_select_next_event_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_auto_select_next_event_help(inputs)
	if (locale === "ja") return ja_options_editor_auto_select_next_event_help(inputs)
	if (locale === "hi") return hi_options_editor_auto_select_next_event_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_auto_select_next_event_help(inputs)
	return en_options_editor_auto_select_next_event_help(inputs)
});